import Vue from "vue";
import Router from "vue-router";
import LoginView from "../views/LoginView";
import DashboardView from "../views/DashboardView";
import SensorsView from "../views/SensorsView";
import ReportsView from "../views/ReportsView";
import ProfileView from "../views/ProfileView";
import store from "../store";

Vue.use(Router);

const routes = [
    {
        path: "",
        redirect: store.getters.isAuthenticated ? 'dashboard' : 'login'
    },
    {
        path: "/",
        redirect: store.getters.isAuthenticated ? 'dashboard' : 'login'
    },
    {
        path: "/login",
        name: "login",
        component: LoginView
    },
    {
        path: "/dashboard/:id?",
        name: "dashboard",
        component: DashboardView,
        meta: {requiresAuth: true}
    },
    {
        path: "/sensors/:id?",
        name: "sensors",
        component: SensorsView,
        meta: {requiresAuth: true}
    },
    {
        path: "/reports",
        name: "reports",
        component: ReportsView,
        meta: {requiresAuth: true, restricted: true}
    },
    {
        path: "/profile/:id?",
        name: "profile",
        component: ProfileView,
        meta: {requiresAuth: true}
    },
    {
        path: "*",
        redirect: "dashboard"
    }
];

const router = new Router({
    mode: "history",
    routes
});

/**
 * Before each routing, check the meta. If it requires auth,
 * check if it is authenticated. Else, redirect to login.
 * In other words - this is middleware and only redirect
 * when not authenticated.
 */
router.beforeEach((to, from, next) => {
        if (to.matched.some(record => record.meta.requiresAuth)) {

            if (!store.getters.isAuthenticated) {
                if (to.path !== '/') next({name: "login", query: {redirect: to.fullPath}})
                else next({name: "login"})
            }
            if (store.getters.isAuthenticated && to.matched.some(record => record.meta.restricted)) {
                if (store.getters.isStaff) next()
                else next({name: "dashboard"})
            }
            next(); // is auth
        }
        next();  // no auth required
});

export default router;